import './App.css';
import PublicFileAccess from "./components/PublicFileAccess";
import React, { Suspense, lazy, useCallback, useEffect, useMemo, useState } from 'react';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'));

function App() {
  // Check if URL is a public file access link (/f/{code})
  const isPublicFileAccess = window.location.pathname.startsWith('/f/');
  const [authNotice, setAuthNotice] = useState('');
  const [authState, setAuthState] = useState({ activeUser: null, isAuthenticating: false });

  const isAuthenticated = useMemo(() => !!authState.activeUser, [authState.activeUser]);

  useEffect(() => {
    if (isPublicFileAccess) return;

    const path = window.location.pathname || '';
    const hasPathSignal = path !== '/' && !path.startsWith('/f/');
    if (hasPathSignal) {
      setAuthNotice('Authentication detected. Loading your data...');
    }
  }, [isPublicFileAccess]);

  const handleAuthStateChange = useCallback(({ activeUser, isAuthenticating }) => {
    setAuthState({ activeUser, isAuthenticating });
    if (activeUser || !isAuthenticating) {
      setAuthNotice('');
      return;
    }
    setAuthNotice('Authentication underway. Loading your data...');
  }, []);

  const authNoticeBanner = authNotice ? (
    <div
      style={{
        position: 'absolute',
        top: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '10px 16px',
        background: 'rgba(33, 133, 208, 0.95)',
        color: '#fff',
        borderRadius: '999px',
        fontSize: '14px',
        zIndex: 1100,
        boxShadow: '0 10px 24px rgba(0,0,0,0.15)',
      }}
    >
      {authNotice}
    </div>
  ) : null;

  return (
    <div className="App">
      <header></header>
      {isPublicFileAccess ? (
        <PublicFileAccess />
      ) : (
        <>
          {!isAuthenticated && authNoticeBanner}
          <Suspense fallback={authNoticeBanner}>
            <AuthenticatedApp onAuthStateChange={handleAuthStateChange} />
          </Suspense>
        </>
      )}
    </div>
  );
}

export default App;
